import { render, staticRenderFns } from "./add-to-cart.vue?vue&type=template&id=3d613ad6&"
import script from "./add-to-cart.vue?vue&type=script&lang=js&"
export * from "./add-to-cart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/__w/one-stop-shop/one-stop-shop/one-stop-shop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3d613ad6')) {
      api.createRecord('3d613ad6', component.options)
    } else {
      api.reload('3d613ad6', component.options)
    }
    module.hot.accept("./add-to-cart.vue?vue&type=template&id=3d613ad6&", function () {
      api.rerender('3d613ad6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "web/wp-content/themes/global-theme/views/pages/productAside/Actions/add-to-cart.vue"
export default component.exports